export default __webpack_public_path__ + "static/media/elgin-branco.b481dcd5.png";